module.exports = __webpack_public_path__ + "img/b156f82.png";